import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { computed, onMounted, ref } from "vue"

import DefaultLayout from "@layout/layouts/DefaultLayout.vue"
import AuthLayout from "@layout/layouts/AuthLayout.vue"

import { useRoute, useRouter } from "vue-router"
import { useAuthStore } from "@auth/store/authStore"
import LoaderGlobal from "@layout/components/LoaderGlobal.vue"
import { PATHS } from "@global/utils/PATHS"
import { useSubscriptionsStore } from "@billing/store/subscriptions"
import { useLayoutStore } from "@layout/store/layout"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const isLoading = ref(true)

const router = useRouter()
const route = useRoute()
const authStore = useAuthStore()
const subscriptionsStore = useSubscriptionsStore()
const layoutStore = useLayoutStore()

const isAuthRoute = computed(() => {
  return route.meta.layout === "auth"
})

authStore.router = router

const accessToken = localStorage.getItem("gt-access-token")
const expiresAt = localStorage.getItem("gt-expires-at")
const refreshToken = localStorage.getItem("gt-refresh-token")

if (accessToken && expiresAt && refreshToken) {
  authStore.setAuthData({ accessToken, expiresAt, refreshToken })
}

onMounted(async () => {
  if (!authStore.isAuthorized) {
    isLoading.value = false
    return
  }

  const userResponse = await authStore.getCurrentUser()

  if (!userResponse) {
    isLoading.value = false
    return
  }

  const isPageForbiddenBecauseUserHaveNotOrganization =
    !authStore.isMemberOfOrganization &&
    !["/my-companies/list", "/my-companies/requests", "/"].includes(
      route.path
    ) &&
    !route.path.includes("/invitations")

  if (isPageForbiddenBecauseUserHaveNotOrganization) {
    await router.push(PATHS.home)
  }

  isLoading.value = false

  await subscriptionsStore.getCurrentSubscription()
  await layoutStore.showOnboardingIfNeeded()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(LoaderGlobal, { key: 0 }))
      : _createCommentVNode("", true),
    (!isLoading.value && _unref(isAuthRoute))
      ? (_openBlock(), _createBlock(AuthLayout, { key: 1 }))
      : _createCommentVNode("", true),
    (!isLoading.value && _unref(authStore).isAuthorized && !_unref(isAuthRoute))
      ? (_openBlock(), _createBlock(DefaultLayout, { key: 2 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})